<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="imei-error-modal"
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <div>
                <animated-info class="mx-auto mb-4"></animated-info>
            </div>
            <h4 class="text-center mb-4">{{ $t('bp.ImeiErrorModal.title') }}</h4>
            <p class="text-center mb-4">
                {{ $t('bp.ImeiErrorModal.subTitle') }}
            </p>
        </div>
    </b-modal>
</template>

<script>
    export default {
    }
</script>

<style scoped>

</style>